import type { SVGProps } from 'react';

const SvgAssetTypePlaceholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6 19c-.55 0-1-.45-1-1s-.45-1-1-1-1 .45-1 1c0 1.65 1.35 3 3 3 .55 0 1-.45 1-1s-.45-1-1-1m14-2c-.55 0-1 .45-1 1s-.45 1-1 1-1 .45-1 1 .45 1 1 1c1.65 0 3-1.35 3-3 0-.55-.45-1-1-1M18 5c.55 0 1 .45 1 1s.45 1 1 1 1-.45 1-1c0-1.65-1.35-3-3-3-.55 0-1 .45-1 1s.45 1 1 1M6 3C4.35 3 3 4.35 3 6c0 .55.45 1 1 1s1-.45 1-1 .45-1 1-1 1-.45 1-1-.45-1-1-1M4 14c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1m16-4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1m-7-7h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1m0 16h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgAssetTypePlaceholder;
